import Header from './components/TheHeader';
import Sidebar from './components/TheSidebar';
import { useTimeZoneStorage } from '@/composables/date/useTimeZoneStorage';
import useUserSettings from '@/composables/useUserSettings.query';
import { useUiThemeProfile } from '@/composables/useUiThemeProfile';
import { setGlobalTimeZone } from '@/utils/dateTimeFns';
import { useSignalR } from '@/signalr/composable';
import { useRoute } from 'vue-router/composables';
import { ref, computed, watchEffect } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    const timeZoneLoaded = ref(false);
    useUiThemeProfile();
    const route = useRoute();
    const isNextAppPage = computed(() => {
      return Boolean(route.meta.isNextAppPage);
    });
    const {
      result: userSettings
    } = useUserSettings();
    const {
      timeZone
    } = useTimeZoneStorage();
    const signalr = useSignalR();
    signalr.init().catch(error => console.error(error));
    watchEffect(() => {
      if (userSettings.value?.timeZone) {
        timeZone.value = userSettings.value.timeZone;
        setGlobalTimeZone(userSettings.value.timeZone);
        timeZoneLoaded.value = true;
      }
    });
    return {
      __sfc: true,
      timeZoneLoaded,
      route,
      isNextAppPage,
      userSettings,
      timeZone,
      signalr,
      Header,
      Sidebar
    };
  }
};